import { Subject, Subscription } from 'rxjs';
import { WebsocketService } from 'src/app/shared/services/websocket/websocket.service';
import { Injectable, Injector, OnDestroy } from '@angular/core';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';

export type IHandlersEvent = (value: any) => void;
interface IHandlers { [action: string]: (send: IHandlersEvent, res: any) => void; }

@Injectable()
export class Websocket implements OnDestroy {
  private handlers: IHandlers;
  private subcription: Subscription;
  private ws: WebsocketService;

  public connected: boolean;
  public events: Subject<any>;

  constructor(handlers?: IHandlers) {
    const injector: Injector = InjectorService.get();

    Object.assign(this, {
      events: new Subject<any>(),
      handlers: {
        PING: (send: IHandlersEvent) => {
          send({ action: 'PONG' });
          send({ action: 'GET_NEW_MESSAGES' });
        },
        ...(handlers) && handlers
      },
      ws: injector.get(WebsocketService)
    });

    this.subscribe();
  }

  private subscribe(): void {
    this.subcription = this.ws.connection.subscribe((res: any) => {
      (this.handlers[res.action]) ? this.handlers[res.action](this.send.bind(this), res) : this.events.next(res);
    });
  }

  public send(value: any): void {
    if (this.connected) {
      this.ws.send(value);
    }
  }

  public ngOnDestroy(): void {
    this.subcription.unsubscribe();
    this.ws.close();
  }
}
